import React, { createContext } from 'react';

interface IDealCOntext {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contextValue: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContextValue: React.Dispatch<React.SetStateAction<any>>;
}
export const DealContext = createContext<IDealCOntext>({
  contextValue: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setContextValue: () => {},
});
